<template>
  <GlobalMaintenanceGate />
  <AppLayout v-if="!isAuthPage" />
  <router-view v-else />
</template>

<script setup>
import { computed } from 'vue'
import { useRoute } from 'vue-router'
import AppLayout from '@/components/ui/AppLayout.vue'
import GlobalMaintenanceGate from '@/components/ui/GlobalMaintenanceGate.vue'
import { AUTH_PAGE_PATHS } from '@/config/constants'

const route = useRoute()
// 登录、忘记密码等独立全屏页，不渲染顶部导航与主布局
const isAuthPage = computed(() => AUTH_PAGE_PATHS.includes(route.path))
</script>

<style lang="scss">
// 全局样式已在 theme.scss 中定义
</style>
